import { backendBaseUrl, runtimeEnv } from "@/core/lib/runtime-env";

export const isProd =
  runtimeEnv("VITE_DEPLOYMENT_ENVIRONMENT") === "production";

export const config = {
  backendUrl: backendBaseUrl(),
};
